import React, { useState, useEffect } from "react";

import ChatMobile from "./ChatMobile";
import DocumentsMobile from "./DocumentsMobile";

function HomeMobile() {
    const [view, setView] = useState('chat');
    
    useEffect(() => {
        return () => {
            setView('chat');
        };
    }, []);

    if (view === 'chat') {
        return <ChatMobile view={view} setView={setView} />;
    }

    if (view === 'documents') {
        return <DocumentsMobile view={view} setView={setView} />;
    }
}

export default HomeMobile;